import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { getCardLimits } from "../../../services/api/banking/cards";

export const QUERY_CARD_LIMITS = "QUERY_CARD_LIMITS";

export const useQueryCardLimits = (
  cardId: string,
  config?: WSQueryConfig<cardApiSpec.GetCardLimitsResponse, WSServiceError>
) => {
  return useWSQuery<cardApiSpec.GetCardLimitsResponse, WSServiceError>(
    [QUERY_CARD_LIMITS, cardId],
    () => getCardLimits(cardId),
    {
      retry: false,
      ...config
    }
  );
};
